import i18n from 'i18next';

export const PACKETS_INPUT_FIELDS_DATA = {
	submitUrl: 'packet',
	fetchUrl: 'packet',
	cancelButtonPath: 'packet',
	defautlFieldValues: {
		title: '',
		description: '',
		short_description: ''
	},
	inputFields: [
		{
			name: 'title',
			label: i18n.t('packets:fields.title'),
			type: 'text',
			required: true
		},
		{
			name: 'description',
			label: i18n.t('packets:fields.description'),
			type: 'textarea',
			required: true
		},
		{
			name: 'short_description',
			label: i18n.t('packets:fields.short_description'),
			type: 'textarea',
			required: true
		}
	]
};
